import AmericanExpressIcon from '~assets/images/payment/american_express.svg';
import defaultCreditCardIcon from '~assets/images/payment/credit_card.svg';
import MasterCardIcon from '~assets/images/payment/mastercard.svg';
import VisaIcon from '~assets/images/payment/visa.svg';
import { ObjectValues } from '~types/typeUtils';

export enum OrderPaymentTypes {
	CREDIT_CARD = 'creditCard',
	CASH = 'cash',
	CASH_CARD = 'cashCard',
	CHECK = 'check',
	ACH = 'ach',
	OTHER = 'other',
}

export enum OfflinePaymentMethodsValues {
	CHECK = 'check',
	CASH = 'cash',
	ACH = 'ach',
	CREDIT_CARD = 'creditCard',
}

export const PAYMENT_PROCESSORS = {
	ach: 'ach',
	cash: 'cash',
	cashCard: 'cashCard',
	CCI: 'CCI',
	check: 'check',
	creditCard: 'creditCard',
	ESD: 'ESD',
	Laundroworks: 'Laundroworks',
	other: 'other',
	SpyderWash: 'SpyderWash',
	stripe: 'stripe',
	worldNet: 'world_net',
} as const;
export type PAYMENT_PROCESSORS_TYPE = ObjectValues<typeof PAYMENT_PROCESSORS>;

/** Order payment statuses */
export const PAYMENT_STATUS = {
	PAID: 'PAID',
	BALANCE_DUE: 'BALANCE_DUE',
	PENDING: 'PENDING',
	INVOICING: 'INVOICING',
	INVOICED: 'INVOICED',
	INVOICE_PAID: 'INVOICE_PAID',
} as const;
export type PAYMENT_STATUS_TYPE = ObjectValues<typeof PAYMENT_STATUS>;

export enum PaymentStatusDisplayValue {
	Unpaid = 'Unpaid',
	Paid = 'Paid',
	PartiallyPaid = 'Partially paid',
	Invoicing = 'Invoicing',
	Invoiced = 'Invoiced',
	InvoicePaid = 'Invoice paid',
	Pending = 'Pending',
}

export const PAYMENT_TIMING = {
	'POST-PAY': 'POST-PAY',
	'PRE-PAY': 'PRE-PAY',
} as const;
export type PAYMENT_TIMING_TYPE = ObjectValues<typeof PAYMENT_TIMING>;

export enum CARD_BRAND {
	MASTERCARD = 'mastercard',
	VISA = 'visa',
}

export enum StripePaymentMethodType {
	CARD = 'card',
	ACH = 'us_bank_account',
}

export enum BankAccountType {
	CHECKING = 'checking',
	SAVINGS = 'savings',
}

export enum PaymentStatuses {
	SUCCEEDED = 'succeeded',
	CANCELED = 'canceled',
	PROCESSING = 'processing',
	FAILED = 'failed',
	REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
	REQUIRES_CONFIRMATION = 'requires_confirmation',
	REQUIRES_ACTION = 'requires_action',
	REQUIRES_CAPTURE = 'requires_capture',
	CARD_DECLINE_RATE_LIMIT_EXCEEDED = 'card_decline_rate_limit_exceeded',
	INSUFFICIENT_FUNDS = 'insufficient_funds',
	TRANSACTION_NOT_ALLOWED = 'transaction_not_allowed',
}

export const PAYMENT_VERIFICATION_INTERVAL = 2500;
export const MAX_VERIFICATION_TIME = 60000;
export const MAX_TRIES = MAX_VERIFICATION_TIME / PAYMENT_VERIFICATION_INTERVAL;

export const PAYMENT_DATE_FORMAT = 'ddd. MM/DD/YYYY, hh:mma z';

export const cardBrandMapping = {
	visa: VisaIcon,
	mastercard: MasterCardIcon,
	master: MasterCardIcon,
	amex: AmericanExpressIcon,
	unknown: defaultCreditCardIcon,
} as const;
